"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.GetReceiptsButton=exports.DigitalReceiptsHeading=void 0;const DigitalReceiptsHeading=exports.DigitalReceiptsHeading=_styledComponents.default.h2`
  font-style: normal;
  font-weight: 600 !important;
  font-size: 20px !important;
  line-height: 24px !important;
  font-feature-settings: "liga" off, "calt" off;
  margin: 24px 0px 12px 0px;
  color: #2a2928;`,GetReceiptsButton=exports.GetReceiptsButton=_styledComponents.default.div`
    min-width:336px;
    max-width: 660px;

    .getReceiptOptionContainer {
    height: fit-content;
    border-radius: 8px;
    border: 1.5px solid #DDD9D5;
    box-sizing: border-box;
    font-size: 16px;
    margin: 8px 0px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

   .getReceiptOptionContainer p {
    margin: 0;
    padding-right: 8px;
    padding-bottom: 2px;
  }

  .getReceiptOption {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .arrIcon {
    font-size: 18px;
  }

  .bg{
    background-color: #FAF9F8
  }

  .mobile{
      width: 336px;
  }
`;